import { render } from "./AddEditMajorCategory.vue?vue&type=template&id=54fe9c5e&scoped=true"
import script from "./AddEditMajorCategory.vue?vue&type=script&lang=js"
export * from "./AddEditMajorCategory.vue?vue&type=script&lang=js"

import "./AddEditMajorCategory.vue?vue&type=style&index=0&id=54fe9c5e&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fe9c5e"]])

export default __exports__